/*
  "Ver mais" for the Café do Mês description.

  The description is clamped to a few lines so the section keeps its designed height.
  The toggle must only appear when the clamp is really hiding something, and that can
  only be known after layout, so the decision is made here rather than in Liquid. It is
  re-checked on resize, because the same text is cut at one width and not at another.

  Opening and closing are animated. A -webkit-line-clamp cannot be transitioned, so the
  clamp is swapped for an explicit max-height for the duration of the animation: measure
  where we are, measure where we are going, then let CSS move between the two. Without
  this the section's height changes in one frame and the whole page jumps.
*/
(function () {
  var DURATION = 320;

  function setup(section) {
    var desc = section.querySelector('[data-cotm-desc]');
    var btn = section.querySelector('[data-cotm-more]');
    if (!desc || !btn) return;

    var animating = false;

    function isClipped() {
      var previous = desc.dataset.expanded;
      desc.dataset.expanded = 'false';
      var clipped = desc.scrollHeight - desc.clientHeight > 1;
      desc.dataset.expanded = previous;
      return clipped;
    }

    function refresh() {
      if (animating) return;
      if (desc.dataset.expanded === 'true') {
        btn.dataset.needed = 'true';
        return;
      }
      btn.dataset.needed = isClipped() ? 'true' : 'false';
    }

    function animate(to) {
      var from = desc.getBoundingClientRect().height;
      animating = true;

      // Freeze the current height, then release the clamp so the full height can be measured.
      desc.style.transition = 'none';
      desc.style.maxHeight = from + 'px';
      desc.style.overflow = 'hidden';
      desc.dataset.expanded = 'true';
      var full = desc.scrollHeight;
      desc.dataset.expanded = to ? 'true' : 'false';
      var target = to ? full : collapsedHeight();

      // Force the frozen height to apply before the transition starts.
      void desc.offsetHeight;
      desc.style.transition = 'max-height ' + DURATION + 'ms cubic-bezier(.4,0,.2,1)';
      desc.dataset.expanded = 'true';          // keep the clamp off while moving
      desc.style.maxHeight = target + 'px';

      window.setTimeout(function () {
        desc.style.transition = '';
        desc.style.maxHeight = '';
        desc.style.overflow = '';
        desc.dataset.expanded = to ? 'true' : 'false';
        animating = false;
        refresh();
      }, DURATION);
    }

    function collapsedHeight() {
      var previous = desc.dataset.expanded;
      var inlineMax = desc.style.maxHeight;
      var inlineOvf = desc.style.overflow;
      desc.style.maxHeight = '';
      desc.style.overflow = '';
      desc.dataset.expanded = 'false';
      var h = desc.getBoundingClientRect().height;
      desc.dataset.expanded = previous;
      desc.style.maxHeight = inlineMax;
      desc.style.overflow = inlineOvf;
      return h;
    }

    btn.addEventListener('click', function () {
      if (animating) return;
      var opening = desc.dataset.expanded !== 'true';
      btn.setAttribute('aria-expanded', opening ? 'true' : 'false');
      btn.textContent = opening ? btn.dataset.less : btn.dataset.more;
      animate(opening);
    });

    var timer;
    window.addEventListener('resize', function () {
      clearTimeout(timer);
      timer = setTimeout(refresh, 150);
    });

    refresh();
    // Fonts and images land after first paint and change where the text wraps.
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(refresh);
    window.addEventListener('load', refresh);
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-cotm-section]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
